import { IDemoRegistrationForm } from "@models/DemoRegistrationForm.model";
import { Draft } from "./Draft.util";
import { getCalculateProgressParams } from "./getCalculateProgressParams";

export const getDemoGroupProgressParams = (
  draft: Draft<IDemoRegistrationForm["group"]>
) => {
  const { description, name, people } = draft;
  const requiredFieldsValues = [description, name, people];
  return getCalculateProgressParams(requiredFieldsValues);
};
